module.exports = __webpack_public_path__ + "static/media/image-header.f36e76de.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/image-header.png
// module id = 645
// module chunks = 8